import { Dialog } from "construct-ui";
import ViewBase from "../../view-base.view";
import SiteSoldToShipToMappingModel from "../../../models/sold-to-ship-to/site-sold-to-ship-to-mapping.model";
import { exportExecutespExcelTemplate, downloadUserFileByFileID } from "../../../models/file.model"
import moment from "moment";
import { formats } from "../../../config/constants";
/**
 * Site Sold-to Mapping - Excel Upload Dialog
 *
 * The upload dialog used to download and upload according to the filters provided
 *
 * @author cmc.nttruong1
 */
export default function SiteSoldToShipToMappingExcelUploadDialog() {
  ViewBase.call(this);

  const BOOTSTRAP_INVALID_CLASS = "is-invalid";
  const ACCEPTED_FILE_FORMAT = ".xlsx";
  const FORM_ID = "siteSoldToShipToMappingExcelUploadForm";
  const UPLOAD_INPUT_ID = "siteSoldToShipToMappingExcelUploadInput";

  let errorMessage = "";

  const downloadSiteSoldToShipToMappingExcelFormat = (filters) => {
    this.showLoading();
    const fileName = "SiteSoldToShipToMappingTemplate";
    const exportConfig = {
      storedProcedureCode: "28", // change it
      params: [],
      excelSheetNames: ["SiteSoldToShipToMapping"],
    };
    exportExecutespExcelTemplate(exportConfig, fileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const upload = (e, onUploaded) => {
    e.preventDefault();
    if (!validate()) {
      e.stopPropagation();
      return;
    }

    this.showLoading();
    let file = document.querySelector(`#${UPLOAD_INPUT_ID}`).files[0];
    SiteSoldToShipToMappingModel.uploadExcel(file)
      .then((result) => {
        this.showMessage(this.getText('EM00000313', 'Upload Completed'), this.getText('LT00000475', 'Success'), () => {
          const fileId = result.fileId;
          const fileName = `UploadResultSiteSoldToShipToMapping_${moment().format(formats.apiDateFormat)}`
          downloadUserFileByFileID(fileId, fileName);
          onUploaded();
        });
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const validate = () => {
    // Form validation
    if (!this.validateForm()) {
      errorMessage = this.getText("EM00000316", "Please select a file");
      return false;
    }

    let fileUploadInput = document.querySelector(`#${UPLOAD_INPUT_ID}`);
    if (!fileUploadInput.files[0].name.endsWith(ACCEPTED_FILE_FORMAT)) {
      fileUploadInput.classList.add(BOOTSTRAP_INVALID_CLASS);
      errorMessage = this.getText("EM00000058", "Invalid file.");
      return false;
    }

    // in the event where previously was incorrect and it's been corrected, remove the invalid class
    fileUploadInput.classList.remove(BOOTSTRAP_INVALID_CLASS);
    return true;
  };

  return {
    view: ({ attrs: { filters, isOpen, onClose, onUploaded } }) => {
      return m(Dialog, {
        isOpen,
        onClose,
        class: "cui-dialog-l",
        title: this.getText("LT00000861", "Batch Upload Mapping"),
        content: m(
          "container",
          m(
            "ol",
            m(
              "li.fw-bold.mb-4",
              m(".mb-2", this.getText("LT00000018", "Excel Download")),
              m(
                "button.btn.btn-primary",
                {
                  onclick: () => {
                    downloadSiteSoldToShipToMappingExcelFormat(filters);
                  },
                },
                m("i.bi.bi-file-earmark-arrow-down-fill"),
                this.getText("LT00000218", "Download Template")
              )
            ),
            m("hr"),
            m(
              "li.fw-bold.mb-4",
              m(".mb-2", this.getText("LT00000197", "Excel Upload")),
              m(
                "form.position-relative.needs-validation[novalidate]",
                {
                  id: FORM_ID,
                  onsubmit: (e) => { upload(e, onUploaded) }
                },
                m("input.form-control", {
                  id: UPLOAD_INPUT_ID,
                  type: "file",
                  accept: ACCEPTED_FILE_FORMAT,
                  required: true,
                }),
                m(".invalid-tooltip", errorMessage)
              )
            )
          ),
          this.getBaseViews()
        ),
        footer: m(
          ".d-flex.gap-2.justify-content-end",
          m(
            "button.btn.btn-primary",
            { type: "submit", form: FORM_ID },
            this.getText("LT00000290", "Upload")
          ),
          m(
            "button.btn.btn-white",
            { onclick: onClose },
            this.getText("LT00000021", "Close")
          )
        ),
      });
    },
  };
}
